export const guidelines = [
  {
    label: '• Mínimo de 8 caracteres',
    test: (value: string) => value.length >= 8,
  },
  {
    label: '• Mínimo 1 número',
    test: (value: string) => /\d/.test(value),
  },
  {
    label: '• Mínimo 1 letra maiúscula',
    test: (value: string) => /[A-Z]/.test(value),
  },
  {
    label: '• Mínimo 1 letra minúscula',
    test: (value: string) => /[a-z]/.test(value),
  },
  {
    label: '• Mínimo 1 caractere especial (@*!%;:.)',
    test: (value: string) => /[!-/:-@[-`{-~]/.test(value),
  },
  {
    label: '• Campos “Senha” e “Confirmação de senha” devem ser idênticos',
    test: (value: string, confirmation: string) => confirmation === value,
  },
]
